(ns practitest.frontend.components.forms
  (:require [clojure.string :as str]))

;; Form state handling
;; Every form has a state:
;;
;; formprops
;;
;; fieldprops
;;   id
;;   validators
;;
;
;;; formprops
;{
; :id :form1
; ; Is this entity new or are we editing existing one ?
; :new? true
; :edit? false
;
; }
;
;;; formstate
;{
; ;; Fields state
; :fields {:field1 {
;                   :dirty? false
;                   :touched? false
;
;                   ;; Force validation
;                   :validate? false
;
;                   ;; Validation errors if any
;                   :errors [{:id ::validatosr-id
;                             :message ""}]
;                   :field-ref (atom with field Ref)
;                   }}
; }
(comment
  {:fields {:field-id {:value "Val"}}})

(defn get-field-value
  [form-state field-id]
  (get-in form-state [:fields field-id :value]))

(defn get-fields-values
  [form-state field-ids]
  (reduce
    (fn [result field-id]
      (assoc result field-id (get-field-value form-state field-id)))
    {}
    field-ids))

(defn assoc-field-value
  [form-state field-id value]
  (assoc-in form-state [:fields field-id :value] value))

(defn init-form-state
  [form-state object]
  (when (map? object)
    (reduce-kv
      (fn [form-state k v]
        (assoc-field-value form-state k v))
      form-state
      object)))

(defn dirty!
  [form-state field-id]
  (assoc-in form-state [:fields field-id :dirty?] true))

(defn dirty?
  [form-state field-id]
  (boolean (get-in form-state [:fields field-id :dirty?] false)))

(def validators
  {::value-present    {:id        ::value-present
                       :message   (fn [value]
                                    "This field is required")
                       :predicate (fn [value]
                                    (some? value))}

   ::user-selected    {:id        ::user-selected
                       :message   (fn [value]
                                    "User must be selected")
                       :predicate (fn [value]
                                    (some? value))}

   ::url-valid        {:id ::url-valid
                       :message (fn [value] "URL must start with http(s)://")
                       :predicate (fn [value]
                                    (if (str/blank? value)
                                      true
                                      (or (str/starts-with? value "http://")
                                          (str/starts-with? value "https://"))))}

   ;; Special validator for multilist
   ;; It can be either string or collection
   ::multilist-validator {:id ::multilist-validator
                          :message (fn [value]
                                     "This field is required")
                          :predicate (fn [value]
                                       ;; TODO: fix this
                                       (cond
                                         (string? value)
                                         (not= "[]" value)

                                         (coll? value)
                                         (not (empty? value))

                                         :else
                                         false))}

   ::string-not-blank {:id        ::string-not-blank
                       ;; TODO: more params to message fn
                       :message   (fn [value]
                                    "This field is required")
                       ;; TODO: more params to predicate
                       :predicate (fn [value]
                                    (and (some? value)
                                         (string? value)
                                         (not (str/blank? value))))}

   ::xbot-num-files-range {:id        ::xbot-num-files-range
                       :message   (fn [value]
                                    "Number of files must be between 0 and 5")
                       :predicate (fn [value]
                                    (and (some? value)
                                         (<= 0 value 5)))}})

(defn validate-one
  [validator-id value]
  (try
    (if-let [{:keys [message predicate] :as validator} (get validators validator-id)]
      (when-not (predicate value)
        {:id      validator-id
         :message (message value)})
      (js/console.warn "Validator" validator-id "referenced is not found in validators map"))
    (catch js/Error e
      (js/console.warn e "Validation error"))))

(defn validate-all
  [validators value]
  (reduce (fn [errors validator]
            (if-let [e (validate-one validator value)]
              (conj errors e)
              errors))
          []
          validators))

(def test-type->skipped-fields
  (let [common-skipped-fields #{:scenario :charter :num_of_results :script_path}]
    {"ExploratoryTest" #{:scenario :num_of_results :script_path}
     "BDDTest" #{:charter :num_of_results :script_path}
     "xBotTest" #{:scenario :charter}
     "ScriptedTest" common-skipped-fields
     "ApiTest" common-skipped-fields
     "FirecrackerTest" common-skipped-fields}))

(defn skip-and-clean-field-validation? [test-type field]
  (contains? (get test-type->skipped-fields test-type #{}) field))

(defn force-form-validation! [{:keys [set-form-state
                                      get-form-state
                                      get-field-props]
                               :as   form-props}]
  (let [new-form-state (let [form-state @(get-form-state)
                             test-type (get-in form-state [:fields :test_type :value])]
                         (reduce
                           (fn [form-state field]
                             (update-in form-state [:fields field]
                                        (fn [field-state]
                                          (let [props @(get-field-props field)]
                                            (if (skip-and-clean-field-validation? test-type field)
                                              (assoc field-state :errors [])
                                              (assoc field-state :errors (validate-all (:validators props) (:value field-state))))))))
                           form-state
                           (keys (:fields form-state))))]
    (set-form-state new-form-state)
    new-form-state))

(defn collect-form-errors [form-state]
  (into {}
        (comp
          (map (fn [[field field-state]]
                 (if (seq (:errors field-state))
                   [field (:errors field-state)]
                   nil)))
          (remove nil?))
        (:fields form-state)))
